import Component from 'can/component/component';
import { range } from 'd3-array';

import { hideTooltip } from '../tooltipHelpers';

import template from './summary.stache';

const ROUND_COUNT = 4;

Component.extend({
    tag: 'probability-summary',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            showRoundVideo: {
                type: 'boolean',
                value: false,
            },
            pageType: {
                type: 'string',
            },
            rounds: {
                get() {
                    return range(ROUND_COUNT).map((r) => `Round ${r + 1}`);
                },
            },
            showLeaders: {
                type: 'boolean',
            },
            activeTooltipId: {
                type: 'string',
                value: null,
            },
            noData: {
                get() {
                    return this.attr('chartsData.length') === 0;
                },
            },
        },
        hideTooltip() {
            const tooltip = this.attr('tooltip');
            hideTooltip(tooltip);
        },
    },
});
